<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="printTable" :tab="$t('tab.printList')" style="margin-top: -14px">
        <print-table ref="printTable" @dblClick="dblClick"/>
      </a-tab-pane>
      <a-tab-pane key="printConfig" :tab="$t('tab.printConfig')" forceRender style="margin-top: -14px">
        <print-config ref="printConfig"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
        <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
        <vxe-button :disabled="activeKey==='printConfig'" content="button.uploadTemplate" size="mini" status="primary" @click="uploadTemplate"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
import PrintTable from '@/views/config/print/PrintTable.vue'
import PrintConfig from '@/views/config/print/PrintConfig.vue'

export default {
    name: 'Print',
    components: {PrintConfig, PrintTable},
    data() {
      return {
        activeKey: 'printTable'
      }
    },
    methods: {
      dblClick(record) {
        this.activeKey = 'printConfig'
        this.$refs.printConfig.resetPage()
        this.$refs.printConfig.refresh(record)
      },
      add() {
        this.$refs[this.activeKey].add()
      },
      save() {
        this.$refs[this.activeKey].save()
      },
      refresh() {
        this.$refs[this.activeKey].refresh()
      },
      uploadTemplate() {
        this.$refs[this.activeKey].uploadTemplate()
      }
    }

  }
</script>